import { useAxios } from './useAxios';
import branding from '@config/branding';
export const useAPI = (endpoint, options) => {
  return useAxios(branding.services.endpoint, endpoint, {
    // withCredentials: true, 
    method: "POST",
    ...options
  });
};